import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CenteredLayoutComponent } from './centered.component';






import { SearchModule } from 'src/app/layout/common/search/search.module';




@NgModule({ exports: [CenteredLayoutComponent], imports: [RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        SearchModule,
        CenteredLayoutComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CenteredLayoutModule {}
